/**
 * 1. 数据库有数据 + 有身份 + 签署条款不为null formType 0  所有内容disable 也无按钮
 * 2. 数据库有数据 + 有身份 + 签署条款为null formType 1 按钮为 推送consent
 * 3. 数据库有数据 + 无身份 formType 2 按钮设置为更新身份
 * 4. 数据库无数据 + 无身份 formType 3 按钮设置为 更新身份并推送consent
 * 5. 数据库无数据 + 有身份 formType 4 按钮设置为 推送consent
 */
import { envName, URL_ROOT, CONSENT_CORP_ID, CONSENT_APP_ID, CONSENT_AGENT_ID } from '@/env';
import React, { useEffect, useState } from 'react';
import { Checkbox, Radio, Button, Spin, Result, Avatar, Form, Divider, Tag, message } from 'antd';
import { SendOutlined } from '@/icons';
import styles from './index.module.less';
import {
    getAgreementInfo,
    getWxConfig,
    openCutsomerInfo,
    saveAgreementInfo,
} from '@/api/open';
import { getWecomJsConfig } from '@/api/wecomJsApi';
import useTitle from '@/hook/useTitle';

const mobileOrigin =
    envName === 'PROD'
        ? 'https://external.wecom.abbvie.com.cn'
        : envName === 'UAT'
            ? 'https://external.wecom-uat.abbvie.com.cn'
            : 'https://project09.weavingbeautiful.vip';
let urllink = `${mobileOrigin}/#/pages/wecom/mobile/agreement`;

const corpId = CONSENT_CORP_ID;
const appId = CONSENT_APP_ID;
const agentId = CONSENT_AGENT_ID;
let url = URL_ROOT + '/wx/mobile/send';
export default function WxSend() {
    useTitle('用户授权同意书');
    const [form] = Form.useForm();
    useEffect(() => {
        initWx();
    }, []);

    const [loading, setLoading] = useState(true);
    const [customerInfo, setCustomerInfo] = useState(null);
    const [formType, setFormType] = useState(0);
    const [isRoom, setIsRoom] = useState(false);
    const [userId, setUserId] = useState(null);
    const [end, setEnd] = useState(false);

    function initWx() {
        setLoading(true);
        setIsRoom(false);
        getWxConfig(corpId, url).then(res => {
            window.wx.config({
                beta: true, // 必须这么写，否则wx.invoke调用形式的jsapi会有问题
                debug: false,
                ...res.data,
                jsApiList: ['sendChatMessage', 'getCurExternalContact'],
            });
            getWecomJsConfig(appId, url).then(res => {
                window.wx.agentConfig({
                    corpid: res.data.appId, // 必填，企业微信的corpid，必须与当前登录的企业一致
                    agentid: agentId, // 必填，企业微信的应用id （e.g. 1000247）
                    timestamp: res.data.timestamp, // 必填，生成签名的时间戳
                    nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
                    signature: res.data.signature, // 必填，签名，见附录-JS-SDK使用权限签名算法
                    jsApiList: ['sendChatMessage', 'getCurExternalContact'], //必填，传入需要使用的接口名称
                    success: function (res) {
                        window.wx.invoke('getCurExternalContact', {}, function (res) {
                            if (res.err_msg == 'getCurExternalContact:ok') {
                                let userId = res.userId;
                                // let userId = 'wmGlbxEQAAWmP_Oyc89ztT4fwSxazcLw';
                                setUserId(userId);
                                // 判断这个人是否签署过
                                getAgreementInfo(userId).then(res => {
                                    if (res.data) {
                                        // setHasIdentify(true);
                                        // 回显数据
                                        let formData = res.data;
                                        // 判断是否有身份
                                        if (formData.identity) {
                                            // 判断客户是否填写
                                            if (formData.clause1) {
                                                formData.clause1 = formData.clause1 == '1';
                                                form.setFieldsValue(formData);
                                                setFormType(0);
                                                // setIsWrite(true);
                                            } else {
                                                form.setFieldsValue(formData);
                                                setFormType(1);
                                                // setIsWrite(false);
                                            }
                                        } else {
                                            formData.clause1 = formData.clause1 == '1';
                                            form.setFieldsValue(formData);
                                            setFormType(2);
                                        }
                                        // setIsCreate(false);
                                    } else {
                                        setFormType(3);
                                    }
                                    openCutsomerInfo(userId).then(res => {
                                        setCustomerInfo(res.data.data);
                                        setLoading(false);
                                    });
                                });
                            } else {
                                if (
                                    res.err_msg ==
                                    'getCurExternalContact:fail_without context of external contact'
                                ) {
                                    setIsRoom(true);
                                } else {
                                }
                                setLoading(false);
                            }
                        });

                        // 回调
                    },
                    fail: function (res) {
                        if (res.errMsg.indexOf('function not exist') > -1) {
                            setLoading(false);
                            alert('版本过低请升级');
                        }
                    },
                });
            });
        });
    }

    function change(e) {
        // setHasIdentify(true);
        if (formType == 3 || formType == 4) {
            setFormType(4);
        } else {
            setFormType(2);
        }
    }

    function updateIdentify(values) {
        setEnd(true);
        let postData = {
            externalUserid: userId,
            identity: null,
            clause1: false,
        };
        let keys = Object.keys(values);
        if (keys.length > 0) {
            keys.forEach(key => (postData[key] = values[key]));
        }
        postData.clause1 = postData.clause1 ? '1' : '0';
        saveAgreementInfo(appId, postData).then(res => {
            // alert(JSON.stringify(res));
            if (res.status == 200) {
                message.success(`更新身份成功`);
                setFormType(0);
            } else {
                message.error('发生未知错误');
            }
            setEnd(false);
        });
    }

    function sendMsg(values) {
        let postData = {
            externalUserid: userId,
            identity: null,
            clause1: null,
        };
        if (typeof values['identity'] == 'undefined') {
            message.error('请更新身份');
        } else {
            let { unionid } = customerInfo;
            window.wx.invoke(
                'sendChatMessage',
                {
                    msgtype: 'news', //消息类型，必填
                    enterChat: true, //为true时表示发送完成之后顺便进入会话，仅移动端3.1.10及以上版本支持该字段
                    news: {
                        // link: `${URL_ROOT}/wx/mobile/agreement?unionId=${unionid}&externalUserId=${userId}`, //H5消息页面url 必填
                        link: `${urllink}?unionId=${unionid}&externalUserId=${userId}`, //H5消息页面url 必填
                        title: '用户授权同意书', //H5消息标题
                        desc: '请点击用户授权同意书', //H5消息摘要
                        imgUrl: `${URL_ROOT}/abbv-consent.png`, //H5消息封面图片URL
                    },
                },
                function (res) {
                    if (res.err_msg == 'sendChatMessage:ok') {
                        //发送成功
                        postData['identity'] = values['identity'];
                        saveAgreementInfo(appId, postData).then(res => {
                            if (res.status == 200) {
                                // message.success(`提交成功`);
                            } else {
                                message.error('发生未知错误');
                            }
                        });
                    }
                },
            );
        }
    }

    function renderHtml() {
        if (isRoom) {
            return (
                <Result
                    status="404"
                    style={{ marginTop: 20, backgroundColor: 'transparent' }}
                    title="无法在群组中使用"
                    subTitle="无法在群组中使用"
                />
            );
        } else {
            return (
                <Form form={form} onFinish={formType == 2 ? updateIdentify : sendMsg}>
                    <Form.Item>
                        <div className={styles.userInfo}>
                            <div className={styles.avatar}>
                                <Avatar src={customerInfo.avatar} size={60} shape="square" />
                                {customerInfo.realName ? (
                                    <Tag color="#55acee" className={styles.identify}>
                                        已实名
                                    </Tag>
                                ) : (
                                    <Tag color="#eaeaea" className={styles.identify}>
                                        未实名
                                    </Tag>
                                )}
                            </div>
                            <div>
                                <div className={styles.name}>{customerInfo.name}</div>
                                <div className={styles.realName}>{customerInfo.realName}</div>
                            </div>
                        </div>
                    </Form.Item>

                    <Form.Item name="id" hidden />
                    <Divider>身份</Divider>
                    <Form.Item name="identity">
                        <Radio.Group disabled={formType == 0 || formType == 1} onChange={change}>
                            <Radio value="医生">
                                <span style={{ fontWeight: '900' }}>医疗卫生专业人士</span>
                            </Radio>
                            <Radio value="其他">
                                <span style={{ fontWeight: '100' }}>非医疗卫生专业人士</span>
                            </Radio>
                        </Radio.Group>
                    </Form.Item>
                    <Divider>用户授权同意书</Divider>
                    <p className={styles.textP}>
                        欢迎您添加艾伯维医药贸易（上海）有限公司（“艾伯维”、“我们”）企业微信联系人！
                    </p>
                    <p className={styles.textP} style={{ fontWeight: '600' }}>
                        在与艾伯维企业微信联系人交流之前，您应同意并遵守《腾讯微信使用条款和隐私政策》，并仔细阅读本同意书条款并选择接受或不接受。除非您接受本同意书所有条款，否则您应停止与艾伯维企业微信联系人沟通。您与艾伯维企业微信联系人之间的信息分享、传送及获取行为将视为您对本同意书各项条款的接受。
                    </p>
                    <p style={{ fontWeight: '600' }}>◼︎︎&nbsp;&nbsp;&nbsp;&nbsp;隐私声明</p>
                    <p className={styles.textP}>
                        为了向您提供实名注册和微信号绑定服务，艾伯维可能在必要时处理与您有关的生物可识别信息和身份证件信息等敏感个人数据，
                        以达到
                        <a
                            href="https://www.abbvie.com.cn/privacy.html"
                            style={{ textDecoration: 'underline' }}
                        >
                            《艾伯维网上隐私声明》
                        </a>
                        中所述的目的。如果没有此类数据，我们的企业微信联系人将无法为您提供仅针对医疗卫生专业人士的服务。
                    </p>
                    <p className={styles.textP}>
                        当您使用“快速会议”功能时，为了满足艾伯维内部的合规要求、以及为了向无法参加线上会议或想要回顾会议内容的人士回放会议视频，我们需要收集并记录会议相关音频和视频信息。您会收到录制提醒，如您不同意录制您的声音或画面，可以选择退出快速会议。
                    </p>
                    <p className={styles.textP}>
                        您在点击、浏览或操作我们为您推送的在线文件资料时，我们会自动收集部分在线互动信息，可能包括您的设备类型、IP地址、广告ID，以及您在在线资料上点击、浏览和互动的相关信息，用于管理我们的在线服务和
                        <a
                            href="https://www.abbvie.com.cn/privacy.html"
                            style={{ textDecoration: 'underline' }}
                        >
                            《艾伯维网上隐私声明》
                        </a>
                        中所述的其他目的。
                    </p>
                    <p className={styles.textP}>
                        艾伯维可能会将您的个人数据传输给其在美国的母公司 AbbVie Inc.
                        和其位于其他国家的附属公司，以及AbbVie集团公司以外的个人和实体。
                        关于艾伯维个人数据跨境传输实践的更多信息，包括关于境外接收者的信息，请参阅
                        <a
                            href="https://www.abbvie.com.cn/privacy.html"
                            style={{ textDecoration: 'underline' }}
                        >
                            《艾伯维网上隐私声明》
                        </a>
                        的个人数据国际传输部分。
                    </p>
                    {/* <p className={styles.textP}>
                        当您使用“快速会议”功能时，为了满足艾伯维内部的合规要求、以及为了向无法参加线上会议或想要回顾会议内容的人士回放会议视频，
                        我们需要收集并记录会议相关音频和视频信息。您会收到录制提醒，如您不同意录制您的声音或画面，可以选择退出快速会议。
                    </p> */}
                    <p>您理解并同意：</p>
                    <p className={styles.textP}>
                        <ul>
                            <li>
                                <p>
                                    艾伯维按照上述授权范围和
                                    <a
                                        href="https://www.abbvie.com.cn/privacy.html"
                                        style={{ textDecoration: 'underline' }}
                                    >
                                        《艾伯维网上隐私声明》
                                    </a>
                                    处理您的个人数据。
                                </p>
                            </li>
                            <li>
                                <p>
                                    接收与艾伯维的产品、服务、研究、活动、计划相关的通信，以及其他您可能感兴趣的信息。
                                </p>
                            </li>
                            <li>
                                <p>
                                    按照上述授权范围和
                                    <a
                                        href="https://www.abbvie.com.cn/privacy.html"
                                        style={{ textDecoration: 'underline' }}
                                    >
                                        《艾伯维网上隐私声明》
                                    </a>
                                    ，处理与您有关的生物可识别信息和身份证件信息等敏感个人数据。
                                </p>
                            </li>
                            <li>
                                <p>
                                    按照上述授权范围和
                                    <a
                                        href="https://www.abbvie.com.cn/privacy.html"
                                        style={{ textDecoration: 'underline' }}
                                    >
                                        《艾伯维网上隐私声明》
                                    </a>
                                    ，将您的个人数据传输给境外接收者。
                                </p>
                            </li>
                        </ul>
                    </p>
                    <p className={styles.textP}>
                        如需撤回您的同意，或者如果您对我们处理您的个人数据有任何疑问，请参阅
                        <a
                            href="https://www.abbvie.com.cn/privacy.html"
                            style={{ textDecoration: 'underline' }}
                        >
                            《艾伯维网上隐私声明》
                        </a>
                        “我们的联系信息”部分或与您的医药代表联系。
                    </p>

                    <p style={{ fontWeight: '600' }}>
                        ◼︎︎&nbsp;&nbsp;&nbsp;&nbsp;不良反应与医疗建议免责声明
                    </p>
                    <p className={styles.textP} style={{ fontWeight: '600' }}>
                        请注意，艾伯维企业微信联系人不是您向艾伯维报告不良事件和进行产品投诉的合适渠道。如果您有针对艾伯维产品的不良事件报告请直接邮件至PVChina@abbvie.com。
                    </p>
                    <p className={styles.textP}>
                        在企业微信平台（“本平台”）上，我们不提供关于准确使用艾伯维产品的医疗建议或指导。艾伯维通过本平台提供的信息仅为信息性和教育性之目的。为避免任何疑义，本平台之目的或内容不应视为要求您购买、使用或推荐购买、使用任何艾伯维产品。{' '}
                    </p>
                    <p className={styles.textP}>
                        任何通过使用本平台获得到的有关患者健康状况、临床现象、医学问题、剂量推荐或治疗方案选择的信息、培训、经验分享和真实案例不应当被视为，事实上也不能够代替专业医师和相关医学专业人员的推荐或说明。本平台不提供任何医学分析和结论。此外，您不得依赖本平台，关于治疗方案的实际选择完全取决于您自身决定以及您的执业责任。{' '}
                    </p>
                    <p className={styles.textP}>
                        由本平台提供的产品特征概述及医疗器械的使用说明仅供您参考。关于使用药品和医疗器械的推荐剂量、禁忌症警告、副作用说明，请以相关产品的标签和/或使用说明书为准。{' '}
                    </p>

                    <p style={{ fontWeight: '600' }}>◼︎︎&nbsp;&nbsp;&nbsp;&nbsp;著作权和商标权</p>
                    <p className={styles.textP}>
                        本平台以及在本平台上展示的材料、商标和其他专有材料均归艾伯维及其关联公司和/或其他第三方主体所有并受中国及其所在国知识产权法律保护。除非被明确告知，您应当了解本平台上所有的内容均受著作权保护且未经艾伯维或材料权利人的书面授权，您无论如何不得以任何形式对本平台上的内容全部或部分使用、复制、转载、下载、编辑、发布、分发、传播或开发。{' '}
                    </p>
                    <Form.Item name="clause1" valuePropName="checked" className={styles.check}>
                        <Checkbox disabled>
                            <div className={styles.textP}>
                                我已阅读并理解以上《用户授权同意书》以及《艾伯维网上隐私声明》。我同意艾伯维按其中所述收集、处理和使用我的个人信息。特别是，我同意艾伯维可以按照《用户授权同意书》以及《艾伯维网上隐私声明》中所述处理我的敏感个人信息、与第三方分享我的个人信息以及将我的个人信息传输到中国境外。
                            </div>
                        </Checkbox>
                    </Form.Item>
                    {formType != 0 && (
                        <Form.Item>
                            <div className={styles.btnBlock}>
                                <Button
                                    icon={<SendOutlined />}
                                    type="primary"
                                    htmlType="submit"
                                    disabled={end}
                                >
                                    {(formType == 1 || formType == 4) && '推送同意书'}
                                    {formType == 3 && '更新身份并推送同意书'}
                                    {formType == 2 && '更新身份'}
                                </Button>
                            </div>
                        </Form.Item>
                    )}
                </Form>
            );
        }
    }

    return (
        <div className={styles.container}>
            <div className={styles.content}>
                <Spin spinning={loading}>{!loading && customerInfo && renderHtml()}</Spin>
            </div>
        </div>
    );
}
